import React from 'react';
import { bool, node, string } from 'prop-types';

import EsmsDialog from '../../components/EsmsDialog';

const ConfirmationModal = ({
    children,
    confirm,
    close,
    message,
    onConfirm,
    onClose,
    ...props
}) => {
    // Support to-be-deprecated props
    close && (onClose = close);
    confirm && (onConfirm = confirm);
    message && (children = message);

    function handleConfirm() {
        onConfirm();
        onClose();
    }

    function handleClose() {
        onClose();
    }

    return (
        <EsmsDialog
            onCancel={handleClose}
            onClose={handleClose}
            onConfirm={handleConfirm}
            {...props}
        >
            {children}
        </EsmsDialog>
    );
};

ConfirmationModal.defaultProps = {
    confirmText: 'Confirm',
    onClose:     () => {},
    onConfirm:   () => {},
    open:        false
};

ConfirmationModal.propTypes = {
    children:    node,
    confirmText: string,
    message:     node,
    open:        bool,
    title:       string
};

export default ConfirmationModal;
